/**
 *  Copyright AlpineReplay Inc, 2021. All rights reserved.
 *  Authors: Brian Bal, Leonid Khramov
 */
import { connect } from "react-redux"
import React from "react"
import { withRouter } from "react-router"

import * as actTeam from "../actions/teams"
import * as act from "../actions/staff"

import "./MemberEditContainer.css"
import MemberEditor from "../components/MemberEditor"
import ContainerWithMenu from "./ContainerWithMenu"
import { webApi } from "../../../lib/WebApi"
import Modal from "../../../components/Modal"
import { fullName2FirstLast } from "../../../util/helpers"
import { validateEmail } from "../../../util/validator"
import TRCButton from "../../../trace/TRCButton"
import TRCInput from "../../../trace/TRCInput"
import { pageTitle, Loading } from "trux"

export class MemberEdit extends ContainerWithMenu {
    constructor(props) {
        super(props, "MemberEdit")
        this.onSaveAll = this.onSaveAll.bind(this)
        this.onDeleteUser = this.onDeleteUser.bind(this)
        this.doDeleteUser = this.doDeleteUser.bind(this)
        this.onRequestDeleteModalClose =
            this.onRequestDeleteModalClose.bind(this)
        this.onEditorUpdate = this.onEditorUpdate.bind(this)
        this.onEditorRolesUpdate = this.onEditorRolesUpdate.bind(this)
        this.teamUsersLoaded = this.teamUsersLoaded.bind(this)
        this.state = {
            editorState: {},
            roles: [],
            errors: [],
            isDeleteModalOpened: false,
            serverError: null,
            loadingRoles: true,
        }
    }

    componentDidMount() {
        pageTitle(this.props.title, "Settings - Member Edit")

        if (this.props.match.params.user && this.props.match.params.token) {
            this.props.fromIOS()
            var that = this
            this.props.loginByCode(
                this.props.match.params.user,
                this.props.match.params.token,
                () => {
                    that.props.loadStaff(this.props.divisionId)
                }
            )
        } else {
            console.log(
                "MemberEditContainer.componentDidMount loadStaff",
                this.props.divisionId
            )
            this.props.loadStaff(this.props.divisionId)
        }
        if (this.props.teams.length > 0) {
            console.log(
                "MemberEditContainer.compontentDidMount loadAllTeamsUsers",
                this.props.teams
            )
            this.loadAllTeamsUsers(this.props.teams)
        }
        console.log(
            "MemberEditContainer.componentDidMount",
            "teams.length",
            this.props.teams.length
        )
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.divisionId !== this.props.divisionId) {
            this.props.history.replace(
                `/division/${nextProps.divisionId}/staff`
            )
        }
        console.log(
            "MemberEditContainer.componentWillReceiveProps",
            "teams.length",
            nextProps.teams.length
        )
        if (nextProps.teams.length > 0) {
            console.log(
                "MemberEditContainer.compontentWillReceiveProps loadStaff",
                nextProps.teams
            )
            this.loadAllTeamsUsers(nextProps.teams)
        }
    }

    loadAllTeamsUsers(teams) {
        if (!this.state.initialRoles) {
            let teamIds = teams.map((team) => team.team_id)
            webApi.batchGetTeamsUsers(teamIds).then((ret) => {
                console.log(ret)
                let users = []
                for (let r of ret) {
                    if (r.data) {
                        for (let u of r.data) {
                            // eslint-disable-next-line eqeqeq
                            if (u.user_id == this.props.userId) {
                                users.push(u)
                            }
                        }
                    }
                }
                this.teamUsersLoaded(users)
            })
        }
    }

    teamUsersLoaded(users) {
        console.log("teamUsersLoaded", users)

        let roles = []

        for (let team of this.props.teams) {
            let member = null
            for (let user of users) {
                if (user.team_id === team.team_id) {
                    member = user
                    break
                }
            }

            roles.push({
                id: `team-${team.team_id}`,
                user_id: `${team.team_id}`,
                team_player_id: member ? member.team_player_id : null,
                full_name: team.title,
                short_name: team.abbr,
                is_coach: member ? member.is_coach === "1" : false,
                is_videographer: member
                    ? member.is_videographer === "1"
                    : false,
                is_player: false,
                error: null,
                loading: false,
            })
        }

        this.setState({
            roles: roles,
            users: users,
            rev: Date.now(),
            loadingRoles: false,
        })
    }

    shortenName(full) {
        if (!full) return ""
        if (full.length < 14) return full
        return `${full.substr(0, 6)}...${full.substr(-6, 6)}`
    }

    getInitialRoleForTeam(teamId) {
        if (!this.state.roles) return null
        const item = this.state.roles["" + teamId]
        let val = item ? item : null
        return val
    }

    getRolesList() {
        return this.state.roles
    }

    isFromIOS() {
        return this.props.via === "iosapp"
    }

    hideBack() {
        return this.props.via === "iosapp"
    }

    onClose() {
        if (this.props.via !== "iosapp") {
            var teamId = this.props.match.params.team
            if (teamId === "undefined") {
                for (var d in this.props.navDivisions) {
                    var div = this.props.navDivisions[d]
                    if (div.teams.length > 0) {
                        teamId = div.teams[0].name
                        break
                    }
                }
            }
            this.props.history.replace(`/${teamId}`)
        } else {
            window.location = "traceteams://return/from/account"
        }
    }

    renderContent() {
        const user = this.props.user ? this.props.user : {}

        const roles = this.getRolesList()
        console.log("MemberEditContainer.renderContent", "roles", roles)
        console.log(
            "MemberEditContainer.renderContent",
            "state.roles",
            this.state.roles
        )
        const isOwner = this.isDivisionOwner(this.props.divisionId)

        return (
            <div className="EditMemberPage modal-container content">
                <form id="team_edit" onSubmit={this.onSaveAll}>
                    <MemberEditor
                        user={this.props.user}
                        members={roles}
                        onChange={this.onEditorUpdate}
                        onMemberRoleChanged={this.onEditorRolesUpdate}
                        errors={this.state.errors}
                    />
                    {this.state.loadingRoles && <Loading />}
                    <span
                        className={
                            "error" + (this.state.serverError ? "" : " hidden")
                        }
                    >
                        {this.state.serverError}
                    </span>
                    <div className="trc-grid bottom-buttons">
                        <div className="col ml-push-6 m-ff12 ml-f6">
                            <TRCInput full type="submit" value="Update" />
                        </div>
                    </div>
                </form>

                <div
                    className={
                        "trc-grid delete-buttons" + (isOwner ? "" : " hidden")
                    }
                >
                    <div className="col">
                        <TRCButton ghost whoops onClick={this.onDeleteUser}>
                            Permanently Delete This Member
                        </TRCButton>
                    </div>
                </div>

                <Modal
                    title="Delete Member?"
                    open={this.state.isDeleteModalOpened}
                    onRequestClose={this.onRequestDeleteModalClose}
                    hideCloseBtn={true}
                >
                    <span className="delete-member">{`Are you sure you want to delete member "${user.first_name} ${user.last_name}"?`}</span>
                    <div className="trc-grid buttons modal-delete-buttons">
                        <TRCButton
                            className="col m-f6"
                            whoops
                            onClick={this.doDeleteUser}
                        >
                            Delete
                        </TRCButton>
                        <TRCButton
                            className="col m-f6"
                            secondary
                            onClick={this.onRequestDeleteModalClose}
                        >
                            Cancel
                        </TRCButton>
                    </div>
                </Modal>
            </div>
        )
    }

    onSaveAll(e) {
        console.log(
            "About to submit user data: " +
                JSON.stringify(this.state.editorState)
        )

        const data = this.state.editorState
        let errors = []

        if (!data.title || data.title.trim().length === 0) {
            errors.push({ field: "title", error: "Name can't be empty" })
        }

        if (!data.email || data.email.trim().length < 5) {
            errors.push({ field: "email", error: "Email is required" })
        }

        if (!validateEmail(data.email.trim())) {
            errors.push({
                field: "email",
                error: "Email format is invalid, enter correct email",
            })
        }

        this.setState({ errors: errors })
        e.preventDefault()

        if (errors.length === 0) {
            this.doSaveChanges()
        }
    }

    findChangedRoles() {
        let changedRoles = []

        for (let teamRole of this.state.roles) {
            if (teamRole.role) {
                const assignedRole = teamRole.role
                let update = {
                    user_id: this.props.userId,
                    user: this.props.user,
                    team_id: teamRole.team_id,
                }
                switch (assignedRole) {
                    case "coach":
                        update.is_coach = "1"
                        update.is_videographer = "0"
                        break
                    case "manager":
                        update.is_coach = "0"
                        update.is_videographer = "1"
                        break
                    default:
                        update.is_coach = "0"
                        update.is_videographer = "0"
                        break
                }
                update.is_player = "0"
                update.team_player_id = teamRole.team_player_id
                changedRoles.push(update)
            }
        }
        console.log(
            "MemberEditContainer.findChangedRoles",
            this.state.roles,
            changedRoles
        )
        return changedRoles
    }

    doSaveChanges() {
        const data = this.state.editorState
        const name = fullName2FirstLast(data.title)
        let firstName = name.first_name
        let lastName = name.last_name

        const user = this.props.user
        const newemail = data.email.trim()
        if (
            (newemail !== user.email && newemail !== data.masked_email) ||
            user.first_name !== firstName ||
            user.last_name !== lastName
        ) {
            let updateData = {
                first_name: firstName,
                last_name: lastName,
            }

            if (newemail !== data.masked_email) {
                updateData.email = newemail
            }

            const wthis = this
            webApi
                .updateUser(user.user_id, updateData)
                .then(() => {
                    wthis.props.loadStaff(wthis.props.divisionId)
                    wthis.props.history.goBack()
                })
                .catch((err) => {
                    wthis.setState({ serverError: "Error: " + err.message })
                    console.log(err)
                })
        } else {
            this.props.history.goBack()
        }
    }

    onDeleteUser(e) {
        e.preventDefault()
        this.setState({ isDeleteModalOpened: true })
    }

    doDeleteUser(e) {
        e.preventDefault()
        this.props.deleteUser(
            this.props.user.division_member_id,
            this.props.divisionId
        )
        this.setState({ isDeleteModalOpened: false })
        this.props.history.goBack()
    }

    onRequestDeleteModalClose(e) {
        if (e) e.preventDefault()
        this.setState({ isDeleteModalOpened: false })
    }

    onEditorUpdate(newState, field) {
        console.log("New editor state: " + JSON.stringify(newState))
        const errors = this.state.errors.filter((item) => item.field !== field)
        this.setState({
            editorState: newState,
            errors: errors,
            serverError: null,
        })
    }

    onEditorRolesUpdate(id, kind) {
        console.log("New roles state: ", id, kind)

        let member = null
        let roles = [].concat(this.state.roles)
        for (let role of roles) {
            // eslint-disable-next-line eqeqeq
            if (role.user_id == id) {
                console.log("changeRole match", id)
                role.is_coach = kind === "coach"
                role.is_videographer = kind === "manager"
                member = {
                    team_player_id: role.team_player_id,
                    user_id: this.props.userId,
                    team_id: role.user_id,
                    is_player: "0",
                    is_coach: role.is_coach ? "1" : "0",
                    is_videographer: role.is_videographer ? "1" : "0",
                    loading: true,
                    error: null,
                }
            }
        }
        this.setState({ roles: roles })

        console.log("changeRole", member)
        if (member) {
            let that = this
            this.props.changeRole(member, this.props.divisionId, (m) => {
                console.log("changeRole", m)
                let roles = [].concat(that.state.roles)
                for (let role of roles) {
                    if (role.user_id === m.user_id) {
                        role.loading = m.loading
                        role.error = m.error
                    }
                }
                that.setState({ roles: roles })
            })
        }

        return
        /*
        let roles = this.state.roles
        let keys = Object.keys(newRoles)
        for (let key of keys) {
            let role = newRoles[key]
            let tr = roles.find(tr => tr.team_id === key)
            if (tr) {
                tr.role = role
            }
        }
        */
    }
}

const mapStateToProps = (state, props) => {
    const via = state.via
    const divisionId = parseInt(props.match.params.division_id, 10)
    const userId = parseInt(props.match.params.user_id, 10)
    const users = state.division_staff.value.staff.sort((a, b) => {
        let an = `${a.first_name} ${a.last_name}`
        let bn = `${b.first_name} ${b.last_name}`
        return an.localeCompare(bn)
    })
    const user = users.find((item) => item.user_id === userId)
    let divisions = []
    let title = "Edit Member"
    let teams = []

    // divisions
    if (state.divisions.value) {
        divisions = state.divisions.value
        console.log("MemberEditContainer", "divisions", divisions)

        let div = divisions.find((d) => d.division_id === divisionId)
        console.log("MemberEditContainer", "div", div)
        if (div) {
            teams = div.myTeams
        }
        console.log("MemberEditContainer", "teams", teams)
    }

    // Title
    if (user) {
        title = user.first_name + " " + user.last_name
    }

    return {
        via,
        teams,
        users,
        divisionId,
        userId,
        user,
        divisions,
        title,
        rev: state.rev,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        fromIOS: () => {
            dispatch({
                type: "COMMON_SET",
                key: "via",
                value: "iosapp",
            })
        },
        loginByCode: (userId, code, cb) => {
            webApi
                .loginByCode(userId, code)
                .then(() => {
                    cb(true)
                    dispatch({ type: "COMMON_RESET" })
                    dispatch({
                        type: "COMMON_SET",
                        key: "via",
                        value: "iosapp",
                    })
                })
                .catch((err) => {
                    console.warn("Admin.HomePage.loginByCode.ERROR", err)
                    cb(false)
                })
        },
        loadStaff: (divisionId) => {
            dispatch(act.loadStaffByDivision(divisionId))
        },
        loadTeams: (divisionId) => {
            dispatch(actTeam.loadTeamsByDivision(divisionId))
        },
        changeUser: (userId, data, divisionId) => {
            dispatch(act.updateStaffInDivision(userId, data, divisionId))
        },
        changeRoles: (divisionId, roles) => {
            dispatch(actTeam.updateTeamMembers(divisionId, roles))
        },
        deleteUser: (divisionMemberId, divisionId) => {
            dispatch(act.deleteStaffFromDivision(divisionMemberId, divisionId))
        },
        changeRole: (member, divisionId, cb) => {
            dispatch(actTeam.updateTeamMember(divisionId, member, cb))
        },
    }
}

const MemberEditContainer = withRouter(
    connect(mapStateToProps, mapDispatchToProps)(MemberEdit)
)

export default MemberEditContainer
